<header class="header">
  <div class="breadcrumb">
    @for (item of paginas; track $index) {
      <span class="breadcrumb-item clickable"
          [class.ativo]="item.rota !== ''"
          [class.inativo]="item.rota === ''"
          (click)="navegarParaPagina(item, $index)">
      {{ item.nome }}
    </span>
      @if ($index < paginas.length - 1) {
        <span class="breadcrumb-separator">|</span>
      }
    }
  </div>

  <div class="dummy"></div>

  <div class="user">
    <button class="notif-btn" (click)="toggleMenu('notif')">
      <img
        class="icon"
        [class.notification-badge-icon]="unreadNotificacoesCount > 0 || unreadAvisosCount > 0"
        [src]="unreadNotificacoesCount > 0 || unreadAvisosCount > 0 ? '../../../assets/svg/icons/notificacao_badge_ic.svg' : '../../../assets/svg/icons/notificacoes_ic.svg'"
        alt="Notificações"
      />
    </button>

    <div class="notif-menu" [class.open]="showNotificacoesMenu()">
      <div class="notif-menu-top">
        <div class="text-wrap">
          <p class="notificacoes">Notificações</p>
          <p *ngIf="unreadNotificacoesCount > 0">
            ({{unreadNotificacoesCount}} não lida)
          </p>
        </div>
        <button (click)="toggleMenu('notif')">
          <img alt="fechar" src="../../../assets/svg/icons/close.svg" />
        </button>
      </div>

      <div
        class="notif-menu-item"
        *ngFor="let notificacao of notificacoes"
        [ngClass]="{ 'destaque': notificacao.status.toLowerCase() !== 'visualizado' }"
        (click)="openDetailsModal(notificacao)"
      >
        <div class="text-wrap">
          <img
            [src]="notificacao.status.toLowerCase() === 'visualizado'
                      ? '../../../assets/svg/icons/notif_lida_menu.svg'
                      : '../../../assets/svg/icons/notif_nao_lida_menu.svg'"
            alt="status da notificação"
          />
          <p
            [ngClass]="{ 'destaque-texto': notificacao.status.toLowerCase() !== 'visualizado' }"
          >
            {{notificacao.titulo}}
          </p>
        </div>
      </div>

      <div class="footer">
        <a
          routerLink="/notificacoes"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <p>Visualizar todas</p>
          <img
            alt="ver todas as notificações"
            src="../../../assets/svg/icons/green-arrow-rigth.svg"
          />
        </a>
      </div>
    </div>

    <button class="faq-btn" (click)="goToPage('ajuda-e-suporte')">
      <img alt="ajuda" src="../../../assets/svg/icons/help.svg" />
    </button>
    <span class="user-name" (click)="toggleMenu('user')"
      >{{ userName }}
      <img src="../../../assets/svg/icons/arrow_down.svg" alt=""
    /></span>

    <div class="user-menu" [class.open]="showUserMenu()">
      <div class="user-menu-item" (click)="goToMeuPerfil()">
        <img
          class="user-menu-item-icon"
          src="../../../assets/svg/icons/cracha_colorido_ic.svg"
          alt=""
        />
        <p>Meu perfil</p>
      </div>

      <div class="user-menu-item" (click)="goToPage('ajuda-e-suporte')">
        <img
          class="user-menu-item-icon"
          src="../../../assets/svg/icons/help_colorido_ic.svg"
          alt=""
        />
        <p>Ajuda e Suporte</p>
      </div>

      <div class="user-menu-item" (click)="abrirPoliticaDePrivacidade()">
        <img
          class="user-menu-item-icon"
          src="../../../assets/svg/icons/doc_colorido_ic.svg"
          alt=""
        />
        <p>Política de Privacidade</p>
      </div>

      <div class="user-menu-item" (click)="logout()">
        <img
          class="user-menu-item-icon"
          src="../../../assets/svg/icons/logout_colorido_ic.svg"
          alt=""
        />
        <p>Sair</p>
      </div>
    </div>
  </div>
</header>
